// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__ulSre","inputWrap":"CustomTip_inputWrap__33IJB"};